/* eslint-disable node/no-missing-import */
/* eslint-disable node/no-unsupported-features/es-syntax */
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import StyledIconButton from "ae-base/Base/StyledIconButton";
import Style from "@aetonix/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Dimensions, Platform, StyleSheet, TextInput, View } from "react-native";
import Breakpoints from "react-native-dimensions-breakpoints";
import ErrorMessage from "./Layout/ErrorMessage";
import InputContainer from "./Layout/InputContainer";
import InputLabel from "./Layout/InputLabel";
import types from "./Layout/inputTypes";
import inputStyle from "./Layout/intputStyle";

const isWeb = Platform.OS === "web";
const BUTTON_WIDTH = isWeb ? 40 : 50;
var styles = StyleSheet.create({
	flex: {
		flex: 1
	},
	hoverButtonContainer: {
		alignContent: "center",
		aspectRatio: 1,
		height: "100%",
		justifyContent: "center",
		position: "absolute",
		right: 0,
		width: BUTTON_WIDTH
	},
	inputPaddingForButton: {
		paddingRight: BUTTON_WIDTH
	}
});

export default class Input extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: "",
			hasChanged: false,
			height: "auto",
			textLength: 0,
			maxText: 0,
			maxedHeight: false,
			showPassword: false,
			fieldError: false
		};

		this.maxHeight = Dimensions.get("window").height / 5.2;

		this.handleSizeChange = handleSizeChange.bind(this);
		this.handleOnChangeText = handleOnChangeText.bind(this);
		this.onBlur = onBlur.bind(this);
		this.toggleShowPassword = toggleShowPassword.bind(this);
	}

	render() {
		var props = this.props;
		var context = this.context;
		var schema = props.schema;
		var description = schema.description;
		var placeholder = schema.placeholder || description;
		var errors = props.errors;
		var inputTextSize = {};
		var noEdit = props.noEdit;
		var ariaLabel = props.ariaLabel;
		var defaultValue = props.defaultValue ? props.defaultValue + "" : props.defaultValue;
		var showPassword = this.state.showPassword;
		var localize = context.localize;
		var localizeFrom = context.localizeFrom;

		var height = {
			height: Platform.OS === "web" ? "auto" : this.state.height
		};

		var styleList = [inputStyle.style, height];

		if ((errors && errors.length) || this.state.fieldError) styleList.push(inputStyle.errored);

		if (schema.stretch) styleList.push(styles.flex);

		var additions = {
			style: styleList,
			editable: !noEdit,
			placeholder: context.localize(placeholder) || placeholder,
			placeholderTextColor: Style.colors.tertiary
		};

		if (isWeb) additions.autoComplete = schema.autoComplete;
		else if (Platform.OS === "ios") additions.returnKeyType = "next";
		else if (Platform.OS === "android") {
			additions.returnKeyType = "next";
			additions.underlineColorAndroid = "transparent";
		}

		var format = schema.format;
		var type = schema.type;
		var multiline = schema.multiline || schema.stretch;

		if (format === "email") additions.keyboardType = "email-address";
		if (format === "password") {
			additions.autoCapitalize = "none";
			if (!showPassword) {
				additions.secureTextEntry = true;
			} else {
				additions.secureTextEntry = false;
				additions.keyboardType = Platform.OS === "ios" ? "ascii-capable" : "visible-password";
			}
		}
		if (format === "phone") additions.keyboardType = "phone-pad";
		if (format === "number" || type === "number") {
			if (Platform.OS === "android") additions.autoCapitalize = "words";
			additions.keyboardType = "numeric";
		}
		if (multiline) {
			additions.multiline = true;
			additions.numberOfLines = schema.rows || 2;
			if (Platform.OS === "ios") {
				additions.returnKeyType = "default";
			} else if (Platform.OS === "android") {
				additions.returnKeyType = "none";
			}
		} else if (props.lastField) {
			additions.returnKeyType = "done";
		}

		var renderEye = null;
		if (format === "password") {
			styleList.push(styles.inputPaddingForButton);
		}
		if (format === "password" && !showPassword)
			renderEye = (
				<StyledIconButton
					icon="fa-eye"
					onPress={this.toggleShowPassword}
					emphasized={isWeb}
					iconStyle={{ textAlign: "center" }}
				/>
			);
		else if (format === "password" && showPassword)
			renderEye = (
				<StyledIconButton
					icon="fa-eye-slash"
					onPress={this.toggleShowPassword}
					emphasized={isWeb}
					iconStyle={{ textAlign: "center" }}
				/>
			);

		if (Breakpoints.smallerThan("small")) inputTextSize.fontSize = Style.text.small;

		styleList.push(inputTextSize);

		var onContentSizeChange =
			!this.state.maxText || this.state.maxText >= this.state.textLength ? this.handleSizeChange : null;

		let handleSubmitEditing = props.jumpToNext ? props.jumpToNext : null;
		if (props.autoSubmit) {
			handleSubmitEditing = props.onSubmit;
		} else if (!multiline && props.lastField) {
			handleSubmitEditing = props.onSubmit;
		} else if (multiline) {
			handleSubmitEditing = null;
		}

		var label;
		if(schema !== undefined && schema.localization){
			label = localizeFrom(schema.localization, ".");
		} else if(schema !== undefined && schema.description) {
			label = localize(schema.description) || description;
		} else {
			label = "Text Input"
		}

		const value = this.state.hasChanged
			? this.state.text
			: props.value !== undefined && props.value !== null
			? props.value
			: defaultValue !== undefined && defaultValue !== null
			? defaultValue
			: "";

		return (
			<InputContainer inline={props.inline} errors={errors} stretch={schema.stretch}>
				<InputLabel schema={schema} />
				<ErrorMessage id={context.id_prefix + props.id + "_error"} errors={errors} schema={schema} />
				<View
					style={{
						position: "relative"
					}}
				>
					<TextInput
						ref={props.inputRef}
						id={context.id_prefix + props.id}
						style={{
							flex: 1
						}}
						onChangeText={this.handleOnChangeText}
						accessibilityLabel={label || ariaLabel || "Text Input"}
						defaultValue={defaultValue}
						onSubmitEditing={handleSubmitEditing}
						onFocus={context.dispatch("keyboard:trigger:open")}
						onBlur={this.onBlur}
						onContentSizeChange={onContentSizeChange}
						value={value}
						maxLength={schema.maxLength}
						scrollEnabled={false}
						{...additions}
					/>
					<View style={styles.hoverButtonContainer}>{renderEye}</View>
				</View>
			</InputContainer>
		);
	}
}

function handleSizeChange(event) {
	var schema = this.props.schema;
	if (!schema.multiline) return;
	var height = event.nativeEvent.contentSize.height;
	var minSize = Style.text.hugeHeading + Style.text.tiny;
	this.setState({
		height: height <= minSize ? minSize : height,
		maxedHeight: false,
		maxText: 0,
		numberOfLines: schema.rows || 2
	});
}

function onBlur() {
	var context = this.context;
	var schema = this.props.schema;
	context.dispatch("keyboard:trigger:close")();

	if (schema.type === "number" && this.state.hasChanged) {
		const number = parseFloat(this.state.text);
		if (isNaN(number)) {
			this.setState({ text: "" });
			return;
		}
		this.setState({ text: number.toString() });
	}
}

function handleOnChangeText(text) {
	var length = text.length;
	var schema = this.props.schema;
	var state = {
		textLength: length,
		text: text,
		hasChanged: true,
		fieldError: false
	};
	if (this.state.height >= this.maxHeight && !this.state.maxedHeight) {
		state.maxText = length;
		state.maxedHeight = true;
	}
	this.setState(state);
	if (schema.type === "number") {
		let number = parseFloat(text);
		const isEmpty = text === "";
		if (isNaN(number) && !isEmpty) {
			this.setState({ fieldError: true });
			this.props.onChange("");
			return;
		}
		if (isEmpty) {
			number = "";
		}
		this.props.onChange(number);
		return;
	}

	this.props.onChange(text);
}

function toggleShowPassword() {
	var password = this.state.showPassword;
	this.setState({
		showPassword: !password
	});
}

Input.propTypes = types;

Input.contextTypes = {
	id_prefix: PropTypes.string,
	localize: PropTypes.func,
	dispatch: PropTypes.func,
	localizeFrom: PropTypes.func,
};
